import PropTypes from "prop-types"
import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import Header from "semantic-ui-react/dist/es/elements/Header/Header"
import "./DetailsEditor.css"
import Markdown from "markdown-to-jsx"

const DetailsEditor = ({
  heading,
  description: Description,
  supplement,
  children,
  iconImage: IconImage,
  ...rest
}) => (
  <Grid stackable {...rest}>
    <Grid.Row
      divided
      columns={IconImage ? 3 : 2}
      className="DetailsEditor__row"
    >
      {IconImage ? (
        <Grid.Column
          width={2}
          verticalAlign="middle"
          textAlign="center"
          className="DetailsEditor__image"
        >
          {<IconImage width="8em" />}
        </Grid.Column>
      ) : null}
      <Grid.Column width={IconImage ? 8 : 10} className="DetailsEditor__column">
        <Header>
          <Header.Content>{heading}</Header.Content>
          {Description ? (
            <Header.Subheader style={{ paddingBottom: "2em" }}>
              {typeof Description === "function" ? (
                <Description />
              ) : typeof Description === "string" ? (
                <Markdown>{Description}</Markdown>
              ) : (
                Description
              )}
            </Header.Subheader>
          ) : null}
        </Header>
      </Grid.Column>
      {supplement ? (
        <Grid.Column width={6} className="DetailsEditor__column">
          <Header
            as="h4"
            content="Common Questions"
            style={{ marginBottom: "0" }}
          />
          {supplement}
        </Grid.Column>
      ) : null}
    </Grid.Row>
    <Grid.Row>
      <Grid.Column textAlign="center">{children}</Grid.Column>
    </Grid.Row>
  </Grid>
)

DetailsEditor.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  description: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  supplement: PropTypes.node,
  children: PropTypes.node
}

DetailsEditor.defaultProps = {
  heading: "",
  description: "",
  supplement: null
}

export default DetailsEditor
